import DecisionNodeBase from '~/models/journey/DecisionNodeBase'
import type { WaypointNode } from '~/models/journey/waypoints'
import type { Path } from '~/types/util'

export class PushDsnpToCsNode extends DecisionNodeBase {
  getNext(): WaypointNode | Path | null {
    const { flag } = FeatureFlags.use()
    const pushDsnpToCs = flag<boolean>('dsnp-quote-gate').value

    return this.yesNo(pushDsnpToCs)
  }
}
